export default "__VITE_ASSET__p_x6vF3U__"